'use strict';

module Patersons {

  export interface AccoladeOptionsScope extends ng.IScope {
    accoladeOptionsForm: ng.IFormController;
    parentController: AbstractController;
    events: Patersons.AccoladeOptionsViewCtrl;
    isError: boolean;
    hasData: boolean;
    accoladeOptions: AccoladeOptions;
    isSubmitted: boolean;
    isLoading: boolean;
    enableQuarterlyAccoladeReports: boolean;
    enableAnnualAccoladeReports: boolean;
    hasAccoladeAccounts: boolean;
    isBusy: boolean;
    userCompany: UserCompany;
  }

  export class AccoladeOptionsViewCtrl extends MyDetailsBaseCtrl {
    portfolioService: Patersons.PortfolioService;
    scope: Patersons.AccoladeOptionsScope;
    myDetailsService: Patersons.MyDetailsService;

    static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'myDetailsService', 'portfolioService', 'navigationService', 'userCompanyService'];

    constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, myDetailsService, portfolioService, navigationService, userCompanyService) {
      super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
      this.scope = $scope;
      this.myDetailsService = myDetailsService;
      this.portfolioService = portfolioService;
      this.scope.parentController = this;
      this.scope.events = this;
      this.scope.isError = false;
      this.scope.isSubmitted = false;
      this.scope.isLoading = false;
      this.scope.isBusy = false;
      this.getAccoladeOptions();

      this.scope.isError = false;
      this.scope.hasData = false;
      userCompanyService.getUserCompany().then((company) => {
        this.scope.userCompany = company;
      })
    }

    onSave() {
      this.scope.isBusy = true;

      var promise = this.myDetailsService.updateAccoladeOptions(this.scope.accoladeOptions);
      promise.then(
        (result: AccoladeOptions) => {
          console.info('myDetailsService.updateAccoladeOptions');
          console.info(result);
          this.scope.isSubmitted = true;
          this.scope.isError = false;
          this.scope.hasData = true;
          this.updateAccoladeOptions(result);
        }, (reason) => {
          this.scope.isError = true;
          this.scope.hasData = false;
          this.scope.isSubmitted = false;
        }
      )
        .finally(() => {
          this.scope.isBusy = false;
        });
    }

    onCancel() {
      // reload ourselves if cancelled to get the original settings
      this.redirect("/accoladeOptions");
    }

    getAccoladeOptions() {
      this.scope.isLoading = true;

      let accoladeCheckPromise: Promise<Account[]> = this.portfolioService.getCombinedPortfolioData();
      accoladeCheckPromise.then(
        (accounts: Account[]) => {
          if (accounts.every(account => account.accountType == "Standard")) {
            this.scope.hasAccoladeAccounts = false;
            this.scope.isLoading = false;
          } else {
            this.scope.hasAccoladeAccounts = true;
            var optionsPromise: ng.IHttpPromise<any> = this.myDetailsService.getAccoladeOptions();
            optionsPromise.then(
              (result: AccoladeOptions) => {
                this.log.info("Accolade Opts: result = " + JSON.stringify(result));
                this.updateAccoladeOptions(result);
              },
              (reason) => {
                this.scope.isError = true;
                this.scope.isSubmitted = false;
                this.myDetailsService.errorHandler = reason.data;
              })
              .finally(() => {
                this.scope.isLoading = false;
              });
          }

          this.scope.isError = false;
          this.scope.hasData = true;
        }, (reason) => {
          this.scope.isError = true;
          this.scope.hasData = false;
        });

      return null;
    }

    updateAccoladeOptions(options: AccoladeOptions): void {
      console.info('updateAccoladeOptions');
      console.info(options);
      this.scope.accoladeOptions = options;
      this.scope.enableAnnualAccoladeReports = !this.scope.accoladeOptions.hasElectronicTaxReports;
      this.scope.enableQuarterlyAccoladeReports = !this.scope.accoladeOptions.hasElectronicQuarterlyReports;
    }
  }
}
